import {
  Box,
  HStack,
  VStack,
  Text,
  Image,
  useDisclosure,
} from '@chakra-ui/react';
import { Handle, NodeProps, Position, useReactFlow, Node } from 'reactflow';

import ConditionalNodeIcon from '../../../../assets/projects/conditional_node.svg';
import { ConditionalNodeEditorModal } from './';
import { ConditionalNodeData } from '../../models';
import { NODE_SIZE } from '../../../../constants';

export const ConditionalNode = ({
  id,
  data: { form, conditionField },
}: NodeProps<ConditionalNodeData>) => {
  const {
    isOpen: isConditionalNodeEditorModalOpen,
    onOpen: onConditionalNodeEditorModalOpen,
    onClose: onConditionalNodeEditorModalClose,
  } = useDisclosure();

  const reactFlow = useReactFlow();

  return (
    <Box bg="white" onClick={onConditionalNodeEditorModalOpen}>
      <ConditionalNodeEditorModal
        isOpen={isConditionalNodeEditorModalOpen}
        onClose={newData => {
          onConditionalNodeEditorModalClose();

          if (newData) {
            reactFlow.setNodes((prevNodes: Node<ConditionalNodeData>[] = []) =>
              prevNodes.map(node => {
                if (node.id === id) {
                  return {
                    ...node,
                    data: {
                      ...node.data,
                      conditionField: newData.conditionField,
                    },
                  };
                }
                return node;
              })
            );
          }
        }}
        form={form}
        conditionField={conditionField}
      />

      <Handle
        type="target"
        position={Position.Top}
        id="a"
        style={{ width: NODE_SIZE, height: NODE_SIZE }}
      />

      <VStack
        w="48"
        h="20"
        border="1px"
        borderColor="custom_yellow.2"
        borderRadius="md"
        gap="0"
      >
        <HStack
          bg="custom_yellow.2"
          color="white"
          w="full"
          justify="center"
          flex="1"
        >
          <Image src={ConditionalNodeIcon} />
          <Text fontSize="xs" fontWeight="semibold">
            Conditional Node
          </Text>
        </HStack>

        <HStack flex="1" maxW="48">
          <Box
            textOverflow="ellipsis"
            overflow="hidden"
            whiteSpace="nowrap"
            px="3"
          >
            <Text as={'span'} fontSize="sm">
              {conditionField ? conditionField.title : 'Field'}
            </Text>
          </Box>
        </HStack>
      </VStack>

      <Handle
        type="source"
        position={Position.Bottom}
        id="b"
        style={{ width: NODE_SIZE, height: NODE_SIZE }}
      />
    </Box>
  );
};
